module.exports = __webpack_public_path__ + "img/dstv-smartcard.db8884ea.jpg";